/* eslint-disable */
/**
 * Once you can consume this types from @goodneighbor/api-client
 * you can delete this file
 */

export type ErrorContextValue = number | string;

export const enum ErrorCode {
  UNEXPECTED_ERROR = 'UnexpectedError',
  TOKEN_EXPIRED_ERROR = 'TokenExpiredError',
  CUSTOM_CONTEXTUAL_ERROR = 'CustomContextualError',
  ANOTHER_CONTEXTUAL_ERROR = 'AnotherContextualError'
}

export type ErrorContext = {
  [ErrorCode.ANOTHER_CONTEXTUAL_ERROR]: {
    placeholder: ErrorContextValue;
  };
  [ErrorCode.CUSTOM_CONTEXTUAL_ERROR]: {
    boolValue: ErrorContextValue;
    numberValue: ErrorContextValue;
    stringValue: ErrorContextValue;
  };
};
